import { Col, Row, Select, Space, Table, TablePaginationConfig } from 'antd'
import React from 'react'

import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import usePage from 'src/hooks/usePage'
import { searchTreasureRedeemReport } from 'src/api/reports'
import TreasureRedeemReportSearch from './treasureRedeemReportSearch'

import { EyeOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { SorterResult, TableCurrentDataSource } from 'antd/lib/table/interface'

const { Column } = Table

const TreasureRedeemReportPage: React.FC = () => {
  const {
    pageData,
    onQuery,
    appendSearchForm,
    submitSearchForm,
  } = usePage({
    getData: searchTreasureRedeemReport,
    searchData: searchTreasureRedeemReport,
    searchType: 'POST',
  })

  type SortItem = { field: string; order: 'asc' | 'desc' }

  const handleTableChange = (
    pagination: TablePaginationConfig,
    _filters: Record<string, (string | number | boolean)[] | null>,
    sorter: SorterResult<any> | SorterResult<any>[],
    extra: TableCurrentDataSource<any>
  ) => {
    const current = pagination.current ?? 1
    const pageSize =
      pagination.pageSize ?? (parseInt(pageData.query.pageSize) || 10)

    const sorterArr = Array.isArray(sorter) ? sorter : [sorter]
    const sorts: SortItem[] = sorterArr
      .filter((s) => s && s.field && s.order)
      .map((s) => ({
        field: String(s.field),
        order: s.order === 'ascend' ? 'asc' : 'desc',
      }))

    if (extra.action === 'paginate') {
      appendSearchForm({ buttonAction: '' })
      onQuery({
        page: String(current - 1),
        pageSize: String(pageSize),
      })
      return
    }

    if (extra.action === 'sort') {
      onQuery({
        page: String(current - 1),
        pageSize: String(pageSize),
        sorts: JSON.stringify(sorts),
      })
      return
    }

    if (extra.action === 'filter') {
      onQuery({
        page: String(current - 1),
        pageSize: String(pageSize),
        sorts: JSON.stringify(sorts),
      })
    }
  }

  const handlePdfClick = () => {
    appendSearchForm({ buttonAction: 'Generate Pdf' })
    submitSearchForm()
  }

  const handleCsvClick = () => {
    appendSearchForm({ buttonAction: 'Generate Csv' })
    submitSearchForm()
  }

  return (
    <>
      <TreasureRedeemReportSearch
        appendSearchForm={appendSearchForm}
        submitSearchForm={submitSearchForm}
      />

      <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
        <Col>
          <span style={{ fontSize: 24 }}>
            Search Results ({pageData.total})
          </span>
        </Col>
        <Col>
          <Select
            placeholder="Export"
            style={{ width: 160 }}
            onSelect={(value) => {
              if (value === 'pdf') {
                handlePdfClick()
              } else if (value === 'csv') {
                handleCsvClick()
              }
            }}
            allowClear
          >
            <Select.Option value="pdf">Export as PDF</Select.Option>
            <Select.Option value="csv">Export as CSV</Select.Option>
          </Select>
        </Col>
      </Row>
      <DndProvider backend={HTML5Backend}>
        <Table
          className="table-sorting"
          rowKey="id"
          dataSource={pageData.data}
          loading={pageData.loading}
          onChange={handleTableChange}
          pagination={{
            current: parseInt(pageData.query.page) + 1,
            total: pageData.total,
            pageSize: parseInt(pageData.query.pageSize) || 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50', '100'],
          }}
        >
          <Column dataIndex="userName" title="Name" sorter={{ multiple: 1 }} />
          <Column dataIndex="gameName" title="Game Name" sorter={{ multiple: 2 }} />
           <Column dataIndex="rare" title="Rare" sorter={{ multiple: 6 }} />
           <Column dataIndex="medium" title="Medium" sorter={{ multiple: 5 }} />
           <Column dataIndex="common" title="Common" sorter={{ multiple: 4 }} />
           <Column
            dataIndex="redeemedPoints"
            title="Redeemed Points"
            sorter={{ multiple: 7 }}
          />
          <Column
            dataIndex="createdOn"
            title="Created On"
            sorter={{ multiple: 8 }}
          />
          <Column
            dataIndex="providerCountry"
            title="Country"
            sorter={{ multiple: 3 }}
          />
          
          
         
          
          

          <Column<{ userName: string }>
            title="Action"
            key="url"
            render={(_, record) => (
              <Space size="middle">
                <Link
                  to={`/users/detail/${record.userName}`}
                  className="link-btn"
                >
                  <EyeOutlined />
                </Link>
              </Space>
            )}
          />
        </Table>
      </DndProvider>
    </>
  )
}

TreasureRedeemReportPage.displayName = 'TreasureRedeemReportPage'
export default TreasureRedeemReportPage
